import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-224M84WWPT";
// Only report analytics from the live production domain to keep preview/test traffic out.
const PROD_HOST = "cummingsandcopm.com";

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    if (!window.location.hostname.endsWith(PROD_HOST)) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
};

// Fire a GA4 conversion / key event. Gated to the production domain.
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (!window.location.hostname.endsWith(PROD_HOST)) return;
  window.gtag("event", name, { send_to: GA_ID, ...params });
};
